import { render, staticRenderFns } from "./SliderItem.vue?vue&type=template&id=569d7f41&scoped=true"
import script from "./SliderItem.vue?vue&type=script&lang=js"
export * from "./SliderItem.vue?vue&type=script&lang=js"
import style0 from "./SliderItem.vue?vue&type=style&index=0&id=569d7f41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569d7f41",
  null
  
)

export default component.exports